import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { buildGraphQLFields } from 'src/app/helpers/datesFormat';
import { File } from 'src/entities/file/model/file';
import { ProgrammingService } from 'src/entities/file/model/programming-service';
import { SERVICE_ORDER_FIELDS } from 'src/entities/order/api/order.fragments';
import { environment } from 'src/environments/environment';
import {
  GetProvidersByServiceEnvelope,
  normalizeProvidersByServiceEnvelope,
  parseProvidersByServiceGraphqlError
} from 'src/features/file-services/manage-provider/lib/get-providers-by-service';
import {
  mutationUpdateObservacionesActivity,
  mutationUpdateObservacionesService,
  queryGetActivityObservation,
  queryGetServiceObservation
} from 'src/features/file-services/observaciones/lib/observaciones.graphql';
import { GraphService } from './graph.service';

interface PassengerFields {
  id?: boolean;
  address?: boolean;
  age?: boolean;
  alergias?: boolean;
  city?: boolean;
  country?: boolean;
  dateOfBirth?: boolean;
  dateOfPass?: boolean;
  doe?: boolean;
  documentNumber?: boolean;
  documentType?: boolean;
  email?: boolean;
  firstName?: boolean;
  gender?: boolean;
  height?: boolean;
  idItinerary?: boolean;
  isTC?: boolean;
  lastName?: boolean;
  passportNumber?: boolean;
  phone?: boolean;
  residesInPeru?: boolean;
  restriccionesAlimentarias?: boolean;
  condicionesMedicas?: boolean;
  size?: boolean;
  status?: boolean;
  weight?: boolean;
  createdAt?: boolean;
  updatedAt?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FileService {
  appBranch = environment.appEnv;
  constructor(private queryGQL: GraphService) {}

  ChangeEstadoitinerario(id: any, estado: any, motive: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
      mutation ChangeEstadoItinerario($id: String!, $estado: String!, $motive: String!) {
        changeEstadoItinerarioByArg(id: $id, estado: $estado, motive: $motive)
      }`,
      variables: { id, estado, motive }
    });
  }

  updateMontoItinerary(
    id: String,
    tarifa: String,
    user: String,
    updateGrouped?: boolean
  ) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateTarifaServiceById($id: String!,$tarifa: String!, $user:String!, $updateGrouped: Boolean){
        updateTarifaServiceById(id: $id,tarifa: $tarifa,  user:$user, updateGrouped:$updateGrouped)
      }`,
      variables: { id, tarifa, user, updateGrouped }
    });
  }

  getServiceObservation(serviceId: String) {
    return this.queryGQL.queryGraphQLSales<{
      getServiceObservation?: { observaciones?: string };
    }>({
      query: queryGetServiceObservation,
      variables: { serviceId }
    });
  }

  updateObservacionesServices(id: String, observaciones: String) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: mutationUpdateObservacionesService,
      variables: { id, observaciones }
    });
  }

  updateTarifaOS(id: String, service: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateTarifaOS($id: String!,$service: inputServices_Dto!){
        updateTarifaOS(id: $id,service: $service)
      }`,
      variables: { id, service }
    });
  }

  updateTarifaNP(id: String, service: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateTarifaNP($id: String!,$service: inputServices_Dto!){
        updateTarifaNP(id: $id,service: $service)
      }`,
      variables: { id, service }
    });
  }

  getProgrammingChildFiles({
    exclusiveStartKeyId = null,
    projectionExpression = 'id'
  }: {
    exclusiveStartKeyId?: string | null;
    projectionExpression?: string;
  } = {}) {
    const fields = projectionExpression
      ? buildGraphQLFields(
          projectionExpression
            .split(',')
            .map((fieldExpression) => fieldExpression.trim())
        )
      : 'id ';

    return this.queryGQL.queryGraphQLSales<any>({
      query: `query GetProgrammingChildFiles(
        $exclusiveStartKeyId: String,
        $projectionExpression: String
      ) {
        getProgrammingChildFiles(
          exclusiveStartKeyId: $exclusiveStartKeyId,
          projectionExpression: $projectionExpression
        ) {
          lastEvaluatedKeyId,
          programmingChildFiles {
            ${fields}
          }
        }
      }`,
      variables: { exclusiveStartKeyId, projectionExpression }
    });
  }

  getAllFiles() {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query {
        getAllFiles {
          estadoFile,lastMinute,pendingPreOpIncidents,estadoItinerario,
    			id,
          filePadreId,
          nameClient,
          isSSFFPadre,
          nombreItinerario,
          usuario,
          observaciones,
          dateRange,
          mainGuide {
            providerId,
            providerName
          }
          fileName,
          fileNumber,
          fileExtend,
          paxQuantity,
          tcQuantity,
    			createdAt,
          updatedAt,
          lstPaX {
            flightIds
            Pax
            estado
            grupo
            grupoId
            acumulado
            paxMenu {
              menu {
                id
                nombreMenu
              }
              observaciones
            }
            type
            passengerId
          }
         incidencias{
              estado,
              fechaSolved,
              fechaCreated,
              solutionTime,
              tipoIncidencia,
              reportedBy,
              descIncidencia,
              acciones
            }

          comunidades {
            productId,
            comunidad
         }
        }
      }`,
      variables: {}
    });
  }

  getItineraryActivitiesServices(id: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getItineraryActivitiesServices($id:String!){
        getItineraryActivitiesServices(id:$id){
          itinerary{
            id,
            estadoFile,
            dateRange,
            fileName,
            fileNumber,
            paxQuantity,
            createdAt,
            updatedAt,
            lstPaX {
              Pax,
              estado,
              grupo,
              acumulado,
              pasajero {
                firstName,
                lastName,
                email,
                phone,
                address,
                city,
                state,
                country,
                passportNumber,
                alergias,
                size,
                weight,
                height,
                dateOfBirth,
                flightIds
                age,
                id
                createdAt,
                updatedAt
              },
              paxMenu {
                observaciones,
                menu{
                  id,
                  nombreMenu
                }
              }
            },
               incidencias{
                    estado,
                    fechaSolved,
                    fechaCreated,
                    solutionTime,
                    tipoIncidencia,
                    reportedBy,
                    descIncidencia,
                    acciones
                  }
                itinerarios{
                  services{

                    id,
                    itineraryId,
                    fileName,
                    day,
                    contador,
                    serviceId,
                    providerId,
                    productId,
                    tipoServicio,
                    totalCostoSoles,
                    totalCostoDolares,
                    totalPriceSoles,
                    totalPriceDolares,
                    mainGuide
                    objProvider{
                      nombre
                      id
                    }
                  }
                }
                comunidades{
                  productId,
                  comunidad
               }
          }
          services{
            nombreServicio
            id,
            mainGuide
          }
        }
      }
      `,
      variables: { id }
    });
  }

  getFlightsByItineraryId(itineraryId: String) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getFlightsByItineraryId($itineraryId:String!){
        getFlightsByItineraryId(itineraryId:$itineraryId){
          id
          itineraryId
          flightNumber
          flightCode
          airline
          isExplorandesFlight
          observations
          flightDate
          departureTime
          arrivalTime
          departureAirport
          arrivalAirport
          estado
        }
      }`,
      variables: { itineraryId }
    });
  }

  getItineraryPassengerFlightLinks(itineraryId: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getItineraryPassengerFlightLinks($id: String!) {
        getItinerary(id: $id) {
          lstPaX {
            flightIds
            passengerId
            Pax
            estado
            pasajero {
              id
              firstName
              lastName
            }
          }
          itinerarios {
            services {
              lstPaX {
                flightIds
                passengerId
                Pax
                estado
                pasajero {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }`,
      variables: { id: itineraryId }
    });
  }

  queryGetAllFlightsPaginated({
    projectionExpression,
    exclusiveStartKeyId = null
  }: {
    projectionExpression: string;
    exclusiveStartKeyId: string | null;
  }) {
    const query = `query GetAllFlightsPaginated($exclusiveStartKeyId: String) {
      getAllFlightsPaginated(exclusiveStartKeyId: $exclusiveStartKeyId) {
        isThereMore,
        LastEvaluatedKey,
        lstFlight {
          ${projectionExpression}
        }
      }
    }`;
    return this.queryGQL.queryGraphQLSales<{
      getAllFlightsPaginated: any;
    }>({
      query,
      variables: { exclusiveStartKeyId }
    });
  }

  getItineraryServiceById(id: String) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getItineraryServiceById($id:String!){
        getItineraryServiceById(id:$id){
          id,
          tipoServicio,
          nombreServicio,
          itineraryId,
          observaciones,
          incidencias{
            estado
            fechaCreated
            fechaSolved
            solutionTime
            tipoIncidencia
            reportedBy
            descIncidencia
            acciones
          },
          numOS,
          numReserva,
          estadoReserva,
          estadoOS,
          pagoTesoreria
          idItinerary,
          serviceId,
          productId,
          providerId,
          tarifaId,
          nombreServicio,
          tipoServicio,
          isDeleted,
          cantPersonal,
          costo,
          day,
          margen,
          price,
          tipoMoneda,
          totalPriceDolares,
          totalPriceSoles,
          totalCostoDolares,
          totalCostoSoles,
          utilidad,
          lstPaX{
            estado,
            grupo,
            Pax
          }
        }
      }
      `,
      variables: { id }
    });
  }

  getServiceById(id: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getServiceById($id:String!){
        getServiceById(id:$id){
          id,
          nombreServicio,
          categoriaServicio,
          menu{
            id,
            nombreMenu,
            descripcion
          }
          servicioTransporteInfo{
            tipoDeUnidad,
            tipoDeTren,
            locacionInicio,
            marcaUnidad,

          }
          proveedor{
            nombre
          }

        }
      }
      `,
      variables: { id }
    });
  }

  getMenuNameByServiceId(id: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getMenuNameByServiceId($id: String!) {
        getMenuNameByServiceId(id: $id)
      }`,
      variables: { id }
    });
  }

  getItineraryById(id: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getItinerary($id: String!){
        getItinerary(id:$id){
    			id,
          comunidades{
            productId,
            comunidad
         }
        }
      }`,
      variables: { id }
    });
  }

  getFileByItineraryId(itineraryId: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getFileByItineraryId($itineraryId: String!){
        getFileByItineraryId(itineraryId:$itineraryId){
    			id,
          estadoFile,
          fileName,
          fileNumber,
          paxQuantity,
    			createdAt,
          updatedAt,
          itinerarios{
            services{
              id,
              contador,
              serviceId,
              providerId,

              productId,
              tipoServicio
            }
          }
        }
      }`,
      variables: { itineraryId }
    });
  }

  queryGetFilesBiblia({
    key,
    projectionExpression
  }: {
    projectionExpression?: string;
    key?: string;
  }) {
    const fields = projectionExpression
      ? buildGraphQLFields(
          projectionExpression.split(',').map((pE) => pE.trim())
        )
      : 'id ';

    const query = `query GetFilesPadresEHijosBiblia($projectionExpression:String, $key:String) {
      getFilesPadresEHijosBiblia(projectionExpression: $projectionExpression,key: $key) {
        isThereMore
        LastEvaluatedKey
        resultFiles {
          ${fields}
        }

      }
    }
  `;

    return this.queryGQL.queryGraphQLSales<{
      getAllFileshijosPaginacion: {
        isThereMore: boolean;
        LastEvaluatedKey: string | null;
        resultFiles: any[];
      };
    }>({
      query,
      variables: { projectionExpression, key }
    });
  }

  getAllItinerariesPaginacion({
    key,
    projectionExpression
  }: {
    projectionExpression?: string;
    key?: string;
  }) {
    const fields = projectionExpression
      ? buildGraphQLFields(projectionExpression.split(',').map((f) => f.trim()))
      : 'id ';

    const query = `query getAllItinerariesPaginacion($projectionExpression:String, $key:String) {
      getAllItinerariesPaginacion(projectionExpression: $projectionExpression,key: $key) {
        isThereMore
        LastEvaluatedKey
        resultFiles {
          ${fields}
        }

      }
    }
  `;
    return this.queryGQL.queryGraphQLSales<{
      getAllItinerariesPaginacion: {
        isThereMore: boolean;
        LastEvaluatedKey: string | null;
        resultFiles: any[];
      };
    }>({
      query,
      variables: { projectionExpression, key }
    });
  }

  updateHasDocument(id: string, hasDocument: boolean) {
    return this.queryGQL.mutateGraphQL<any>({
      mutation: `
      mutation updateServiceHasDocument($id:String!,$hasDocument:Boolean!) {
          updateServiceHasDocument(id: $id,hasDocument:$hasDocument)
      }`,
      variables: { id, hasDocument }
    });
  }

  updateServiceTicketValidFechaOperacion({
    hasInvalidFechaOperacion,
    serviceId
  }: {
    serviceId: string;
    hasInvalidFechaOperacion: boolean;
  }) {
    return this.queryGQL.mutateGraphQL<any>({
      mutation: `
      mutation UpdateServiceTicketValidFechaOperacion($serviceId:String!,$hasInvalidFechaOperacion:Boolean!) {
          updateServiceTicketValidFechaOperacion(serviceId: $serviceId,hasInvalidFechaOperacion:$hasInvalidFechaOperacion)
      }`,
      variables: { serviceId, hasInvalidFechaOperacion }
    });
  }

  getFilesBiblia() {
    return this.queryGQL.queryGraphQL<any>({
      query: `query{
        getFilesBiblia{
          id,
          createdAt,
          itineararyDetailedID,
          itineraryID,
          updatedAt,
          modelname,
          fileName,
          fileNumber,
          paxQuantity,
          services{
            id,
            idProducto,
            idProveedor,
            idServicio,
            idTarifa,
            isArchived,
            serviceDay,
            horaInicio,
            itineraryID,
            nombreServicio,
            tipoProveedor,
            tipoServicio
            proveedor{
              id,
              createdAt,
              updatedAt,
              modelName,
              nombre,
              correoReserva,
              tipoProveedor
              alojamientoInfo{
                cantidadHabitaciones,
                capacidadPersonas,
                categoriaAlojamiento
              }
            },
            servicio{
              id,
              descriptivo,
              destino
            },
            tarifa{
              id,
              estadoTarifa,
              monedaTarifa
            }
          }
        }
      }`,
      variables: {}
    });
  }

  getAllServicesReservas() {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query{
        getAllServicesReservas{
          id,
          estadoFile,
          fileNumber,
          fileName,
          dateRange,
          cantPersonal,
          nombreServicio,
          numReserva,
          numOS,
          objProvider{
            nombre,
          },
          estadoReserva,

        }


      }`,
      variables: {}
    });
  }

  getServicesAllFiles() {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query{
        getAllServicesInFiles{

          id,
          isDeleted
          dateRange,
          day,
          nameClient,
          estadoFile,
          idItinerary,
          nombreItinerario,
          fileName,
          fileNumber,
          numReserva,
          numOS,
          numNP
          estadoReserva,
          estadoOS,
          pagoTesoreria,
          serviceId,
          productId,
          providerId,
          tarifaId,
          price,
          costo,
          utilidad,
          margen,
          cantPersonal,
          totalCostoSoles,
          totalCostoDolares,
          totalPriceSoles,
          totalPriceDolares
          tipoServicio,
          tipoMoneda,
          nombreServicio,
          observaciones,
          categoriaServicio,
          tipoServicio,
          dateRange,
          lstPaX{
            Pax,
            estado,
            grupo,
            acumulado,
            pasajero{
              firstName,
              lastName,
              email,
              phone,
              address,
              city,
              state,
              country,
              passportNumber,
              alergias,
              size,
              weight,
              height,
              dateOfBirth,
              flightIds
              age,
              id
              createdAt,
              updatedAt

            }
          },
          objServicio{
            id,
            nombreServicio,
            destino,
            categoriaServicio,
            tipoServicio,
            createdAt,
            updatedAt
          },
          objProducto{
            id,
            nombre,
            categoriaProducto,
            subCategoriaProducto
          },
          objProvider{
            id,
            nombre,
            razonSocial,
            tipoProveedor,
            correoReserva,
            condicionesPagos
            {
              condicionPago,
              modoPago,
              descuento,
              lineaAprobada,
              lineaAprobadaMoneda,
              observacionPago,
              pagoEfectivoMoneda,
              plazoDiasFit,
              plazoDiasGrupos,
              plazoDiasSeries

            }
          },
          objTarifa{
            id,
            monedaTarifa,

            tarifaDia,
            impuesto,
          },
          order {
            ${SERVICE_ORDER_FIELDS}
          },
          isDeleted
          serviceAdicional{
            nameService
          }

        }

      }`,
      variables: {}
    });
  }

  getAllEntradas() {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query{
        getAllEntradas{

          id,
          hasDocument,
          isDeleted
          dateRange,
          day,
          nameClient,
          estadoFile,
          idItinerary,
          nombreItinerario,
          fileName,
          fileNumber,
          numReserva,
          numOS,
          numNP
          estadoReserva,
          estadoOS,
          pagoTesoreria,
          serviceId,
          productId,
          providerId,
          tarifaId,
          price,
          costo,
          utilidad,
          margen,
          cantPersonal,
          totalCostoSoles,
          totalCostoDolares,
          totalPriceSoles,
          totalPriceDolares
          tipoServicio,
          tipoMoneda,
          nombreServicio,
          observaciones,
          categoriaServicio,
          tipoServicio,
          dateRange,
          lstPaX{
            Pax,
            estado,
            grupo,
            acumulado,
            pasajero{
              firstName,
              lastName,
              email,
              phone,
              address,
              city,
              state,
              country,
              passportNumber,
              alergias,
              size,
              weight,
              height,
              dateOfBirth,
              flightIds
              age,
              id
              createdAt,
              updatedAt

            }
          },

          objProvider{
            id,
            nombre,
            razonSocial,
            tipoProveedor,
            correoReserva,
            condicionesPagos
            {
              condicionPago,
              modoPago,
              descuento,
              lineaAprobada,
              lineaAprobadaMoneda,
              observacionPago,
              pagoEfectivoMoneda,
              plazoDiasFit,
              plazoDiasGrupos,
              plazoDiasSeries

            }
          },

          order {
            ${SERVICE_ORDER_FIELDS}
          },
          isDeleted
          serviceAdicional{
            nameService
          }

        }

      }`,
      variables: {}
    });
  }

  getAllTicketsPaginated(projectionExpression?: string, lastKey?: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query GetAllTicketsPaginated($projectionExpression: String, $lastKey: String) {
      getAllTicketsPaginated(projectionExpression: $projectionExpression, lastKey: $lastKey) {
        items {
          id
          idService
          idActivity
          idItinerary
          idTemplate
          tipoCambio
          nombreServicio
          totalCostoSoles
          totalCostoDolares
          editOperation
          newTotalCostoDolares
          newTotalCostoSoles
          paxTickets {
            ticketAdulto
            ticketEstudiante
            ticketNacional
            ticketNino
          }
          objTarifa {
            id
            comision
            monedaTarifa
            tarifaTicket {
              ticketAdulto
              ticketEstudiante
              ticketNacional
              ticketNino
            }
            tipoTarifa
          }
          estadoOS
          observacionOS
          numOS
          fechaPago
          fechaPagoProgramada
          fechaOSGenerada
          isDeleted
          usuario
          estadoTicket
          idOS
          hasDocumentOS
          hasDocument
          hasInvalidFechaOperacion
        }
        lastKey
      }
    }`,
      variables: {
        projectionExpression: projectionExpression || null,
        lastKey: lastKey || null
      }
    });
  }

  getAllServiciosTicket(key?: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query GetAllServiciosTicket($key: String) {
      getAllServiciosTicket(key: $key) {
          LastEvaluatedKey,
          finalServicios {
            service {
              id,
              numOS,
              estadoOS,
              paxQuantity,
              tcQuantity,
              categoriaServicio,
              idItinerary,
              tipoCambio,
              providerId,
              nombreServicio,
              circuitoTren,
              varianteFrecuencia,
              horario,
              day,
              hasInvalidFechaOperacion,
              totalCostoSoles,
              totalCostoDolares,
              editOperation,
              newTotalCostoDolares,
              newTotalCostoSoles,
              ssffproduct,
              productId,
              objTarifa {
                  monedaTarifa
                  tarifaTicket{
                    ticketAdulto,
                    ticketEstudiante
                    ticketNacional
                    ticketNino
                  }
                }
              paxTickets {
              ticketAdulto,
                  ticketEstudiante
                  ticketNacional
                  ticketNino
              }
            },
            itinerary {
              id,
              fileNumber,
              fileExtend,
              estadoItinerario,
              estadoFile,
              pendingPreOpIncidents,
              lastMinute,
              isSSFFPadre,
              startDateFile,
            } ,
            proveedor {
              id,
              nombre,
              condicionesPagos {
                condicionPago,
                plazoDiasFit,
              }
            }
          }
        }
      }`,
      variables: { key }
    });
  }

  updatePaxTicket(
    idService: string,
    ticket: any,
    montoServicio: number,
    usuario: string
  ) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
      mutation updatePaxTicket($idService: String!, $ticket: inputTickets_Dto!, $montoServicio: Float!, $usuario: String!) {
        updatePaxTicket(idService: $idService, ticket: $ticket, montoServicio: $montoServicio, usuario: $usuario){
        id,
        newTotalCostoSoles,
        newTotalCostoDolares,
        paxTickets{
          ticketAdulto,
          ticketEstudiante,
          ticketNacional,
          ticketNino,
        }
        }
      }`,
      variables: { idService, ticket, montoServicio, usuario }
    });
  }

  updateTicketById(id: any, ticket: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
      mutation UpdateTicket($id: String!, $Ticket: inputTickets_Dto!) {
        updateTicketById(id: $id, Ticket: $Ticket){
        id
        }
      }`,
      variables: { id, Ticket: ticket }
    });
  }

  UpdateTicketAndPdfOS(id: any, ticket: any, user: string) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
      mutation UpdateTicketAndPdfOS($id: String!, $Ticket: inputTickets_Dto! ,  $user: String!) {
        UpdateTicketAndPdfOS(id: $id, Ticket: $Ticket ,user: $user){
        id
        }
      }`,
      variables: { id, Ticket: ticket, user }
    });
  }

  getTicketById({ id }: { id: string }) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getTicketById($id: String!) {
         getTicketById(id: $id) {
           id,
           idOS
         }
       }`,
      variables: { id }
    });
  }

  getAllFilesWithServicesAndMenu(tipoServicio: any) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getAllFilesWithServicesAndMenu($tipoServicio:String!){
        getAllFilesWithServicesAndMenu(tipoServicio:$tipoServicio){

          id,
          tcQuantity,
          estadoFile,
          cantPersonasAB,
          nombreItinerario,
          observaciones
          dateRange,
          egresoInsumos,
          insumos{
            id
            cantidad
            unidadMedida
            nombreInsumo
            service{
              nombreServicio
            }
              menu{
              nombreMenu
              }
          }
          services{
            id,
            day,
            confirmInsumosAYB,
            confirmPDFAYB,
            observacionAYB,
            totalesPersonalCampoAYB,
            cantPersonal,
            fechaServicio,
            productId,
            objProducto{
            id
            nombre
            }
            menu{
              descripcion,
              nombreMenu,
              costoMenu,
              id
            }
            nroPersonasPax{
            id,
            numPax,
              }
            lstPaX{
              Pax,
              estado,
              grupo,
              acumulado,
              pasajero{
                firstName,
                lastName,
                email,
                phone,
                address,
                city,
                state,
                country,
                passportNumber,
                alergias,
                size,
                weight,
                height,
                dateOfBirth,
                age,
                id
                createdAt,
                updatedAt

              }
            },
            serviceId,
            nombreServicio,
            objProvider{
              id,
              nombre
            }
          }
          fileName,
          fileNumber,
          lstPaX{
            Pax,
            estado,
            grupo,
            acumulado,
            pasajero{
              firstName,
              lastName,
              email,
              phone,
              address,
              city,
              state,
              country,
              passportNumber,
              alergias,
              size,
              weight,
              height,
              dateOfBirth,
              age,
              id
              createdAt,
              updatedAt,
              restriccionesAlimentarias

            }
          },
        }
      }`,
      variables: { tipoServicio }
    });
  }
  getAllOSProvider() {
    return this.queryGQL.queryGraphQL<any>({
      query: `query{
        getAllOS{
          id,

          numberOS,
          idItinerary,
          estadoOS,
          pagoTesoreria,
          nameEmpresa,
          numberFile,
          estadoFile,
          group,
          nameProveedor,
          razonSocialProveedor,
          codigoReserva,
          fechaProceso,
          fechaAnulacion,
          subTotal,
          igv,
          totalGeneral,
          monedaTarifa,
          servicio{
            fechaOperacion,
            fechaPago,
            idServicio,
            cantPax,
            monto,
            incluye,

          },
          createdAt,
          updatedAt,
        }
      }`,
      variables: {}
    });
  }

  getServicesByFile(id: String) {
    return this.queryGQL.queryGraphQLSales<{
      getServicesByFile: any;
    }>({
      query: `query GetServicesByFile($id: String!){
        getServicesByFile(id:$id){
          id,
          isDeleted
          dateRange,
          day,
          nameClient,
          estadoFile,
          fileExtend,
          idItinerary,
          nombreItinerario,
          fechaPagoProgramada,
          paxAlojamiento,
          tipoTarifaAlojamiento,
          fechaPago,
          ssffproduct,
          fileName,
          fileNumber,
          numReserva,
          numOS,
          numNP
          estadoReserva,
          estadoOS,
          pagoTesoreria,
          serviceId,
          productId,
          providerId,
          tarifaId,
          price,
          costo,
          utilidad,
          margen,
          cantPersonal,
          totalCostoSoles,
          totalCostoDolares,
          totalPriceSoles,
          totalPriceDolares,
          newTotalCostoDolares,
          newTotalCostoSoles,
          editOperation,
          tipoServicio,
          tipoMoneda,
          nombreServicio,
          observaciones,
          categoriaServicio,
          tipoServicio,
          dateRange,
          lstPaX{
            Pax,
            estado,
            grupo,
            acumulado,
            passengerId
            flightIds
          },
          objServicio{
            id,
            nombreServicio,
            destino,
            locacion,
            categoriaServicio,
            tipoServicio,
            createdAt,
            updatedAt
          },
          objProducto{
            id,
            nombre,
            categoriaProducto,
            destino,
            subCategoriaProducto
          },
          objProvider{
            id,
            nombre,
            razonSocial,
            tipoProveedor,
            correoReserva,
            condicionesPagos
            {
              condicionPago,
              modoPago,
              descuento,
              lineaAprobada,
              lineaAprobadaMoneda,
              observacionPago,
              pagoEfectivoMoneda,
              plazoDiasFit,
              plazoDiasGrupos,
              plazoDiasSeries

            }
          },
          objTarifa{
            id,
            monedaTarifa,

            tarifaDia,
            impuesto,
          },
          isDeleted
          serviceAdicional{
            nameService
          }
          }

      }`,
      variables: { id }
    });
  }
  getServicesByFileID(id: String, projectionExpression?: string) {
    const fields = projectionExpression
      ? buildGraphQLFields(projectionExpression.split(',').map((f) => f.trim()))
      : `id,nombreServicio`;
    const query = `
     query getServicesByFileID($id: String!, $projectionExpression: String) {
    getServicesByFileID(id: $id, projectionExpression: $projectionExpression) {
        ${fields}
      }
    }
  `;

    return this.queryGQL.queryGraphQLSales<any>({
      query,
      variables: { id, projectionExpression }
    });
  }

  getFileById(id: String) {
    return this.queryGQL.queryGraphQL<any>({
      query: `query getFile($id: String!){
        getFile(id:$id){
           id,
          services{
            id,
            idProducto,
            idProveedor,
            idServicio,
            idTarifa,
            isArchived,
            itineraryID,
            nombreServicio,
            tipoProveedor,
            tipoServicio,
            serviceDay,
            horaInicio,
            paxMenu{
              pax{
                firstName,
                lastName
              },
              menu{
                nombreMenu
              },
              observaciones
            }
            incidencias{
              tipoIncidencia,
              descIncidencia,
              reportedBy
            },
            personalCampo{
              cocineros{
                id,
                nombre
              },
               asistenteCocina{
                id,
                nombre
              },
               jefePorteador{
                id,
                nombre
              }
              porterosQuantity,
              comunidad,
               jefeArriero{
                id,
                nombre
              }
              carperosQuantity,
              acemCargaQuantity,
              acemSillaQuantity,
              arrieroQuantity,
              fechaTermino,
               tourConductor{
                id,
                nombre
              },
               asistente{
                id,
                nombre
              },
               guiaTrad{
                id,
                nombre
              },
               guiaBike{
                id,
                nombre
              },
               asisBike{
                id,
                nombre
              },
              pax{
                firstName,
                lastName
              }
            }
            producto{
              id,
              nombre,
              categoriaProducto,
              fechaEntrega,
            },

          }

  }
      }`,
      variables: { id }
    });
  }

  getAllCuentaReservas() {
    return this.queryGQL.queryGraphQL<any>({
      query: `query{
        getAllCuentaReservas{
           id,
           agencia,
           categoria,
           DS{
            nameDS,
            correoDS
           },

           ejecutivaReserva{
            nameEjecutivaReserva,
            correoEjecutivaReserva
          },
          practicanteDS{
            namePracticanteDs,
            correoPracticanteDs
          }
        }
      }`,
      variables: {}
    });
  }

  getProgrammingServicesAndOrdersByFile(fileId: string | String) {
    return this.queryGQL.queryGraphQLCore<{
      getProgrammingServicesAndOrdersByFile: ProgrammingService[];
    }>({
      query: `query GetProgrammingServicesAndOrdersByFile($fileId: String!) {
        getProgrammingServicesAndOrdersByFile(fileId: $fileId) {
          id
          serviceId
          idItinerary
          productId
          ssffproduct
          serviceAdd
          day
          startDateService
          observaciones
          nombreServicio
          tipoServicio
          categoriaServicio
          tipoTarifaAlojamiento
          tipoDeUnidad
          mainGuide
          total
          costoInicial
          moneda
          tipoCambio
          costoUnitario
          paxQuantity
          tcQuantity
          hasDocument
          hasInvalidFechaOperacion
          hasOrderedTickets
          orderIssuanceFrozen
          purchaseNoteId
          order {
            ${SERVICE_ORDER_FIELDS}
          }
          lstPaX {
            Pax
            estado
            type
          }
          providerSnapshot {
            id
            nombre
            correoReserva
          }
          serviceSnapshot {
            locacion
          }
        }
      }`,
      variables: { fileId }
    });
  }

  /**
   * Ticketería — una página de summaries (Core).
   * Soft cap ~1000 items (default back), máx 1500. También puede cortar por ~2MB
   * o presupuesto de tiempo → siempre respetar hasMore/lastKey.
   * Filtros UI IGNORADOS en back: solo lastKey (+ limit opcional).
   * lastKey opaco: no parsear ni mutar; null = primera página.
   */
  getTicketeriaServicesPage(
    input: {
      limit?: number | null;
      lastKey?: string | null;
    } = {}
  ) {
    const variablesInput: Record<string, unknown> = {
      lastKey: input.lastKey ?? null
    };
    if (
      input.limit != null &&
      Number.isFinite(input.limit) &&
      input.limit > 0
    ) {
      variablesInput['limit'] = Math.min(Math.floor(input.limit), 1500);
    }

    return this.queryGQL.queryGraphQLCore<{
      getTicketeriaServicesPage: {
        items: any[];
        lastKey: string | null;
        hasMore: boolean;
      };
    }>({
      query: `query GetTicketeriaServicesPage($input: GetTicketeriaServiceSummariesInput) {
        getTicketeriaServicesPage(input: $input) {
          items {
            serviceId
            idItinerary
            startDateService
            ssffproduct
            serviceAdd
            productId
            file {
              fileNumber
              pendingPreOpIncidents
              displayState
              isSSFFPadre
            }
            categoriaServicio
            nombreServicio
            circuitoTren
            varianteFrecuencia
            horario
            paxQuantity
            tcQuantity
            ticketCount
            paxTickets {
              ticketAdulto
              ticketEstudiante
              ticketNacional
              ticketNino
            }
            providerSnapshot {
              id
              nombre
              razonSocial
              correoReserva
              estadoProveedor
              tipoProveedor
              condicionesPagos {
                condicionPago
                plazoDiasFit
                plazoDiasGrupos
                plazoDiasSeries
              }
            }
            total
            moneda
            tipoCambio
            estadoServicioTickets
            order {
              orderId
              orderNumber
              orderStatus
            }
          }
          lastKey
          hasMore
        }
      }`,
      variables: { input: variablesInput }
    });
  }

  /**
   * Prefetch hasta hasMore=false. onPage tras cada response (pintar 1ª ya).
   * Reenvía lastKey tal cual. Sin filtros de API (filtros solo en memoria en UI).
   */
  async loadTicketeriaServicesPageProgressively(
    onPage: (progress: {
      items: any[];
      loadedCount: number;
      hasMore: boolean;
      pageIndex: number;
    }) => void,
    options: {
      /** Soft cap por página; default back 1000, máx 1500. Omitir = default back. */
      limit?: number;
      isCancelled?: () => boolean;
    } = {}
  ): Promise<any[]> {
    type TicketeriaServicesPageResponse = {
      getTicketeriaServicesPage?: {
        items?: any[];
        lastKey?: string | null;
        hasMore?: boolean;
      };
    };

    const limit =
      options.limit != null && options.limit > 0
        ? Math.min(Math.floor(options.limit), 1500)
        : undefined;
    const maxPages = 500;
    const accumulated: any[] = [];
    let lastKey: string | null = null;
    let page = 0;
    let hasMore = true;

    do {
      if (options.isCancelled?.()) {
        return accumulated;
      }

      const data: TicketeriaServicesPageResponse = await firstValueFrom(
        this.getTicketeriaServicesPage({
          lastKey,
          ...(limit != null ? { limit } : {})
        })
      );

      if (options.isCancelled?.()) {
        return accumulated;
      }

      const payload: TicketeriaServicesPageResponse['getTicketeriaServicesPage'] =
        data?.getTicketeriaServicesPage;
      const pageItems: any[] = payload?.items ?? [];
      accumulated.push(...pageItems);
      lastKey = payload?.lastKey ?? null;
      hasMore = Boolean(payload?.hasMore) && Boolean(lastKey);
      page += 1;

      onPage({
        items: pageItems,
        loadedCount: accumulated.length,
        hasMore,
        pageIndex: page - 1
      });
    } while (hasMore && page < maxPages);

    return accumulated;
  }

  /** Ticketería — tickets de un servicio (lazy al expandir). Paint-ready Core. */
  getTicketeriaTicketsByService(input: {
    serviceId: string;
    idItinerary: string;
  }) {
    return this.queryGQL.queryGraphQLCore<{
      getTicketeriaTicketsByService: { tickets: any[] };
    }>({
      query: `query GetTicketeriaTicketsByService($input: GetTicketsByServiceInput!) {
        getTicketeriaTicketsByService(input: $input) {
          tickets {
            id
            createdAt
            paxTickets {
              ticketAdulto
              ticketEstudiante
              ticketNacional
              ticketNino
            }
            objTarifa {
              id
              monedaTarifa
              tipoCambio
              tarifaTicket {
                ticketAdulto
                ticketEstudiante
                ticketNacional
                ticketNino
              }
            }
            total
            costoInicial
            moneda
            estadoTicket
            hasDocument
            hasInvalidFechaOperacion
            order {
              orderId
              orderNumber
              displayCode
              orderStatus
              orderObservation
              scheduledPaymentDate
              freezeDeadlineAt
              paidAt
              pdfStatus
              createdAt
              commissionAmount
              commissionPercent
            }
          }
        }
      }`,
      variables: { input }
    });
  }

  getDetailsByFile(idFile: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query GetServicesByFile ($id:String!) {
        getServicesByFile (id:$id) {
        estadoItinerario,estadoFile,pendingPreOpIncidents,lastMinute,
          id,
          ssffproduct,
          paxTickets {
            ticketAdulto,
            ticketEstudiante,
            ticketNino,
            ticketNacional
          }
          dateRange,
          tipoDeUnidad
          tipoDeTren
          circuitoTren
          varianteFrecuencia
          horario
          frecuenciaTren
          horaSalidaTren
          fechaPago
          fechaPagoProgramada
          tipoTarifaAlojamiento,
          mainGuide,
          categoriaServicio,
          observaciones,
          tipoCambio,
          editOperation,
          newTotalCostoDolares,
          newTotalCostoSoles,
          serviceAdd,
          incidencias{
            estado
            fechaCreated
            fechaSolved
            solutionTime
            tipoIncidencia
            reportedBy
            descIncidencia
            acciones
          },
          objProvider{
            id,
            tipoProveedor,
            correoReserva,
            nombre,
            razonSocial
            condicionesPagos
              {
                condicionPago,
                plazoDiasFit
                plazoDiasGrupos
                plazoDiasSeries

              }
          },
           objServicio{
            id,
            nombreServicio,
            locacion,
            destino,
            categoriaServicio,
            tipoServicio,
            createdAt
            condicionesPagos
              {
                condicionPago,
                plazoDiasFit
                plazoDiasGrupos
                plazoDiasSeries

              }
          },
          objTarifa{
            id,
            monedaTarifa,
            impuesto
          }
          numOS,
          observacionOS,
          numReserva,
          estadoReserva,
          estadoOS,
          estadoNP,
          editOperation,
          numNP,
          pagoTesoreria
          idItinerary,
          serviceId,
          productId,
          providerId,
          tarifaId,
          nombreServicio,
          tipoServicio,
          isDeleted,
          cantPersonal,
          costo,
          day,
          margen,
          price,
          tipoMoneda,
          totalPriceDolares,
          totalPriceSoles,
          totalCostoDolares,
          totalCostoSoles,
          newTotalCostoDolares,
          newTotalCostoSoles,
          paxAlojamiento,
          utilidad,
          hasDocument,
          hasInvalidFechaOperacion,
          lstPaX {
            flightIds
            Pax
            estado
            grupo
            grupoId
            acumulado
            paxMenu {
              menu {
                id
                nombreMenu
              }
              observaciones
            }
            type
            passengerId
          }
          serviceAdicional{
            nameService
            costo
            costoTotal
          }
         }
       }`,
      variables: { id: idFile }
    });
  }

  getItineraryByIds({
    ids,
    projectionExpression
  }: {
    ids: string[];
    projectionExpression?: string;
  }) {
    const fields = projectionExpression
      ? buildGraphQLFields(
          projectionExpression.split(',').map((ex) => ex.trim())
        )
      : `id,
        estadoItinerario,
        estadoFile,
        pendingPreOpIncidents,
        lastMinute,
        tipoItinerario,
        dateRange,
        fileName,
        fileNumber,
        objCliente {
          id,
          createdBy,
          generalInformation {
            brandName,
            email,
            razonSocial
          }
        }`;

    const query = `query GetItineraryByIds($ids: [String!]!, $projectionExpression: String) {
      getItineraryByIds(ids: $ids, projectionExpression: $projectionExpression) {
        ${fields}
      }
    }`;

    return this.queryGQL.queryGraphQLSales<{
      getItineraryByIds: any;
    }>({
      query,
      variables: { ids, projectionExpression }
    });
  }

  getServicesByIds(ids: String[], projectionExpression?: string) {
    const fields = projectionExpression
      ? buildGraphQLFields(projectionExpression.split(',').map((f) => f.trim()))
      : 'id isDeleted';

    const query = `
     query getServicesByIds($ids: [String!]!, $projectionExpression: String) {
    getServicesByIds(ids: $ids, projectionExpression: $projectionExpression) {
        ${fields}
      }
    }
  `;
    return this.queryGQL.queryGraphQLSales<any>({
      query,
      variables: { ids, projectionExpression }
    });
  }

  getDetailsByIdService(idService: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getServicesByIdService($id: String!){
        getServicesByIdService(id: $id){
          id,
          ssffproduct,
          dateRange,
          tipoDeUnidad
          tipoDeTren

          frecuenciaTren
          horaSalidaTren
          fechaPago
          margen
          tipoTarifaAlojamiento,
          tipoServicio
          categoriaServicio,
          observaciones,
          incidencias{
              estado
              fechaCreated
              fechaSolved
              solutionTime
              tipoIncidencia
              reportedBy
              descIncidencia
              acciones
            },
          objProvider{
            id,
            tipoProveedor,
            correoReserva,
            nombre,
            razonSocial
            condicionesPagos
              {
                condicionPago,
                plazoDiasFit
                plazoDiasGrupos
                plazoDiasSeries

              }
          },
           objServicio{
            id,
            nombreServicio,
            destino,
            categoriaServicio,
            tipoServicio,
            createdAt
          },
          objTarifa{
            id,
            impuesto
          },
          fileName,
          fileNumber,
          numOS,
          observacionOS,
          observaciones,
          numReserva,
          estadoFile,
          estadoReserva,
          estadoOS,
          estadoNP,
          numNP,
          mainGuide,
          pagoTesoreria
          idItinerary,
          serviceId,
          productId,
          providerId,
          tarifaId,
          nombreServicio,
          tipoServicio,
          isDeleted,
          cantPersonal,
          costo,
          day,
          price,
          tipoMoneda,
          totalPriceDolares,
          nameClient
          totalPriceSoles,
          totalCostoDolares,
          totalCostoSoles,
          utilidad,
          hasDocument,
          lstPaX{
            estado,
            grupo,
            Pax
          }
          serviceAdicional{
            nameService
            costo
            costoTotal
          }
         }
       }`,
      variables: { id: idService }
    });
  }

  getItineraryActivitiesWithServices(id: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getItineraryActivitiesWithServices($id: String!){
        getItineraryActivitiesWithServices(id: $id){
          id,
          idProducto,
          dayName,
          dayNumber,
          nameProduct,
          dayInItinerary,
          finActividad,
          lstPaX {
            estado,
            passengerId,
            type,
            grupo,
          }
          inicioActividad,
          horaProgramada,
          observaciones,
          tipoSalida,
          services {
            id
            day
            tipoMoneda
            totalCostoDolares
            totalCostoSoles
            totalPriceDolares
            totalPriceSoles
            newTotalCostoDolares
            newTotalCostoSoles
            nombreServicio
            tipoServicio
            hasDocument,
            hasInvalidFechaOperacion,
            categoriaServicio,
            observaciones
            ssffproduct
            lstPaX {
              estado
              passengerId
              type
              grupo
            }
            objTarifa{
              id
              monedaTarifa
            }
            objProvider{
              nombre
              categoriaProveedor
              tipoProveedor
            }
            objServicio{
              locacion
            }
          }
         }
       }`,
      variables: { id: id }
    });
  }

  getItineraryActivities(idItinerary: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getItineraryActivities($idItinerary: String!){
        getItineraryActivities(idItinerary: $idItinerary){
          id,
          idItinerary,
          dayName,
          dayNumber,
          finActividad,
          inicioActividad,
          pickUp,
          dropOff,
          driver,
          horaInicioOperacion,

          usuarioOperador
         }
       }`,
      variables: { idItinerary: idItinerary }
    });
  }

  getActivitiesByIdItinerary(id: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getActivitiesByIdItinerary($id: String!){
        getActivitiesByIdItinerary(id: $id){
          id,
          dayNumber,
          destino,
         }
       }`,
      variables: { id: id }
    });
  }

  getFlightsById(idItinerario: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getFlightsByItineraryId($itineraryId: String!){
        getFlightsByItineraryId(itineraryId: $itineraryId){
          id,
          airline,
          estado,
          arrivalAirport,
          arrivalTime,
          departureTime,
          departureAirport,
          departureTime,
          flightDate,
          flightNumber,
          flightCode,
          observations,
          itineraryId
         }
       }`,
      variables: { itineraryId: idItinerario }
    });
  }

  getPassengersById(idItinerario: string) {
    return this.queryGQL.queryGraphQL<any>({
      query: `query getPassengerById($id: String!){
        getPassengerById(id: $id){
          id
          age
          email
          firstName


          lastName
         }
       }`,
      variables: { id: idItinerario }
    });
  }

  updateActivity(params: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateActivity ($params:inputDayOfItinerary_Dto!) {
        updateActivity (params:$params) { id }
      }`,
      variables: { params }
    });
  }

  addIncidenciaToFile(id: any, incidencia: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation addIncidenciaToFile($id: String!,$incidencia:inputincidencia_Dto!){
        addIncidenciaToFile(id: $id,incidencia:$incidencia){
          id
        }
      }`,
      variables: { id, incidencia }
    });
  }

  changeEstadoIncidenciaFromFile(id: any, incidencia: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation changeEstadoIncidenciaFromFile($id: String!,$incidencia:Float!){
        changeEstadoIncidenciaFromFile(id: $id,incidencia:$incidencia){
          id
        }
      }`,
      variables: { id, incidencia }
    });
  }

  deleteIncidenciaFromActivity(id: any, incidencia: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation deleteIncidenciaFromActivity($id: String!,$incidencia:Float!){
        deleteIncidenciaFromActivity(id: $id,incidencia:$incidencia){
          id
        }
      }`,
      variables: { id, incidencia }
    });
  }

  updateIncidenciaFromFile(id: any, incidencia: any, index: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateIncidenciaFromFile($id: String!,$incidencia:inputincidencia_Dto!,$index:Float!){
        updateIncidenciaFromFile(id: $id,incidencia:$incidencia,index:$index){
          id
        }
      }`,
      variables: { id, incidencia, index }
    });
  }

  sendEmailOS(numberOS: any) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query sendEmailOS($numberOS: String!){
        sendEmailOS(numberOS: $numberOS)
      }`,
      variables: { numberOS }
    });
  }

  changeProvider(
    idRegistro: String,
    idProvider: String,
    user: String,
    servicioId = ''
  ) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation changeProvider(
        $idRegistro: String!
        $idProvider: String!
        $user: String!
        $servicioId: String!
      ){
        changeProvider(idRegistro: $idRegistro, idProvider: $idProvider, user: $user, servicioId: $servicioId) {
          success
          message
        }
      }`,
      variables: { idRegistro, idProvider, user, servicioId }
    });
  }

  changeMultipleProviders(infoServiceProveedor: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
      mutation changeMultipleProviders(
        $infoServiceProveedor: inputInfoServiceProveedor!
      ) {
        changeMultipleProviders(
          infoServiceProveedor: $infoServiceProveedor
        ) {
          success
          staleData
          services {
            id
            providerId
            orderId
          }
        }
      }
    `,
      variables: {
        infoServiceProveedor
      }
    });
  }

  selectMainGuide(
    idRegistro: String,
    idOldGuide: String,
    idItinerary: String,
    mainGuide: any
  ) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation selectMainGuide(
        $idRegistro: String!
        $idOldGuide: String!,
        $idItinerary: String!,
        $mainGuide: inputMainGuide_Dto!
      )
      {
        selectMainGuide(idRegistro:$idRegistro,idOldGuide:$idOldGuide,idItinerary:$idItinerary,mainGuide:$mainGuide)
      }`,
      variables: { idRegistro, idOldGuide, idItinerary, mainGuide }
    });
  }

  changeService(idRegistro: String, servicio: any, user: String) {
    servicio.productId = servicio.productId ? servicio.productId : '0';
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation changeService(
        $idRegistro: String!
        $servicio: inputServices_Dto!
        $user: String!
        ){
          changeService( idRegistro:$idRegistro, servicio:$servicio, user:$user )
      }`,
      variables: { idRegistro, servicio, user }
    });
  }

  getAllPasengersByFileId(fileId: String) {
    return this.queryGQL.queryGraphQL<any>({
      query: `query($fileId: String!){
        getAllPassengersByFileId(fileId:$fileId){
          id,
          age,
          firstName,
          lastName,
          itineraryId
        }
      }`,
      variables: { fileId }
    });
  }

  getPassengerById(id: String) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query(id: String!){
        getPassenger(id:$id){
        firstName,
        lastName

      }
      }`,
      variables: { id }
    });
  }

  getOS(id: String) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query($id: String!){
        getOS(id:$id){
          id,
          idItinerary,
          numberOS,
          nameEmpresa,
          nameClient,
          numberFile,
          group,
          nameProveedor,
          razonSocialProveedor,
          codigoReserva,
          fechaProceso,
          subTotal,
          igv,
          totalGeneral,
          servicio{
            fechaOperacion,
            fechaPago,
            idServicio,
            servicio,
            cantPax,
            monto,
            moneda,
            incluye,
            observaciones

          }
          estadoOS,
          pagoTesoreria,

          createdAt,
        updatedAt

      }
      }`,
      variables: { id }
    });
  }

  getItineraryPassengers(itineraryId: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query
      getItinerary($id:String!){
        getItinerary(id:$id){

          listPassenger
          paxQuantity
          lstPaX {
            flightIds
            Pax
            estado
            grupo
            grupoId
            acumulado
            paxMenu {
              menu {
                id
                nombreMenu
              }
              observaciones
            }
            type
            passengerId
          }

          itinerarios{

            dayNumber
            dayName
            inicioActividad
            finActividad
            totalCostDiaDolares
            totalPriceDiaDolares
            totalUtilidadDiaDolares
            pickUp
            dropOff
            horaInicioOperacion
            driver
            dateActualizacion
            usuarioOperador

            services{

              lstPaX {
                flightIds
                Pax
                estado
                grupo
                grupoId
                acumulado
                paxMenu {
                  menu {
                    id
                    nombreMenu
                  }
                  observaciones
                }
                type
                passengerId
              }
              id
              itineraryId
              idInvoice
              isAccounted
              nombreItinerario
              fileName
              fileNumber
              serviceId
              productId
              providerId
              tarifaId
              day
              price
              costo
              utilidad
              margen
              cantPersonal
              totalPriceSoles
              totalCostoSoles
              totalPriceDolares
              tipoServicio
              tipoMoneda
              nombreServicio
              observaciones
              categoriaServicio
              isDeleted
              numReserva
              estadoReserva
              numOS
              contador
              idContador

              historial
              incidencias{
                tipoIncidencia
                reportedBy
                descIncidencia
              }

            }


          }
        }
        }`,
      variables: { id: itineraryId }
    });
  }

  getItineraryIncidencias(itineraryId: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getItinerary($id: String!){
        getItinerary(id: $id){
            incidencias{
              estado,
              fechaSolved,
              fechaCreated,
              solutionTime,
              tipoIncidencia,
              reportedBy,
              descIncidencia,
              acciones
            }

            itinerarios{
              dayName,
              dayNumber,

              services{
                id

                incidencias{
                  estado
                  fechaCreated
                  fechaSolved
                  solutionTime
                  tipoIncidencia
                  reportedBy
                  descIncidencia
                  acciones

                }
              }

    }
         }
       }`,
      variables: { id: itineraryId }
    });
  }
  updateNumOS(OSDisponible: any, oldNumOS: number, idItinerary: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
      mutation updateNumOS( $OSDisponible: inputNumOSDisponibles!,$oldNumOS:Float!,$idItinerary: String!) {
        updateNumOS(OSDisponible: $OSDisponible,oldNumOS:$oldNumOS,idItinerary: $idItinerary)
      }`,
      variables: { OSDisponible, oldNumOS, idItinerary }
    });
  }

  getItineraryDetailed(itineraryId: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `
      query getItinerary($id: String!) {
        getItinerary(id: $id) {
          estadoItinerario
          estadoFile
          pendingPreOpIncidents
          lastMinute

          id
          nombreItinerario
          tipoItinerario
          diasItinerario
          dateRange
          lastMinute
          archived
          isDeleted

          usuario
          operator
          paxQuantity
          listPassenger

          totalPriceDolares
          totalCostoDolares
          totalUtilidadDolares
          tipoCambio

          clienteId
          nameClient
          objCliente {
            id
            createdBy
            generalInformation {
              brandName
              email
              razonSocial
            }
          }
          pendingPreOpIncidents

          observaciones
          descripcionEmail

          arrivalDate
          dueDate
          createdAt
          updatedAt

          fileName
          fileNumber
          fileExtend
          estadoFile

          mainGuide {
            providerId
            providerName
          }

          equipos {
            id
            categoria
            marcaEquipo
            modeloEquipo
            nombreEquipo
            observacionEquipo
            tallaEquipo
            valoracionEquipo
          }

          selectedSSFF {
            id
          }

          lstPaX {
            passengerId
            Pax
            estado
            grupo
            flightIds
            acumulado
            paxMenu {
              menu {
                id
                nombreMenu
              }
              observaciones
            }
            type
          }

          itinerarios {
            dayNumber
            dayName
            totalCostDiaDolares
            totalPriceDiaDolares
            totalUtilidadDiaDolares

            services {
              id
              itineraryId
              serviceId
              productId
              providerId
              tarifaId
              day

              price
              costo
              utilidad
              margen

              cantPersonal
              totalPriceSoles
              totalPriceDolares
              tipoMoneda

              nombreServicio
              categoriaServicio
              tipoServicio
              observaciones

              numReserva
              estadoReserva
              estadoOS
              pagoTesoreria

              numOS
              contador
              idContador
              isDeleted

              objServicio {
                id
                nombreServicio
                destino
                categoriaServicio
                tipoServicio
                createdAt
                updatedAt
              }

              objProducto {
                id
                nombre
                categoriaProducto
                subCategoriaProducto
              }

              objProvider {
                id
                nombre
                razonSocial
                tipoProveedor
              }

              incidencias {
                tipoIncidencia
                reportedBy
                descIncidencia
                estado
                fechaCreated
                fechaSolved
                solutionTime
                acciones
              }

              lstPaX {
                passengerId
                Pax
                estado
                grupo
                grupoId
                flightIds
                acumulado
                type
                paxMenu {
                  menu {
                    id
                    nombreMenu
                  }
                  observaciones
                }
              }
            }
          }
        }
      }
    `,
      variables: { id: itineraryId }
    });
  }

  mutationUpdatePaxItinerary(idItinerary: string, pax: any) {
    return this.queryGQL.mutateGraphQLSales<{
      updatePaxItinerary: boolean;
    }>({
      mutation: `mutation UpdatePaxItinerary($idItinerary:String!,$pax:PassengerExtendedInput!){
         updatePaxItinerary(idItinerary:$idItinerary,pax:$pax)
      }`,
      variables: { idItinerary, pax }
    });
  }

  mutationUpdateLstPaxItineraryActivities({
    idItinerary,
    newItineraryLstPaX
  }: {
    idItinerary: string;
    newItineraryLstPaX: unknown[];
  }) {
    return this.queryGQL.mutateGraphQLSales<{
      updateLstPax: boolean;
    }>({
      mutation: `query UpdateLstPax($idItinerary:String!,$lstPaX:[inputDetallePassenger!]!){
         updateLstPax(id:$idItinerary,lstPax:$lstPaX)
      }`,
      variables: { idItinerary, lstPaX: newItineraryLstPaX }
    });
  }

  mutationUpdatePassengerField({
    passengerId,
    field,
    value
  }: {
    passengerId: string;
    field: 'restriccionesAlimentarias' | 'condicionesMedicas' | 'alergias';
    value: string;
  }) {
    return this.queryGQL.mutateGraphQLSales<{
      updatePassengerFieldInItinerary: boolean;
    }>({
      mutation: `mutation UpdatePassengerField($passengerId: String!, $field: String!, $value: String!) {
        updatePassengerField(passengerId: $passengerId, field: $field, value: $value)
      }`,
      variables: { passengerId, field, value }
    });
  }

  mutationUpdatePassenger({
    passengerId,
    newPassenger
  }: {
    passengerId: string;
    newPassenger: any;
  }) {
    return this.queryGQL.mutateGraphQLSales<{
      updatePassenger: {
        id: string;
        condicionesMedicas: string;
        restriccionesAlimentarias: string;
        alergias: string;
      } | null;
    }>({
      mutation: `mutation UpdatePassenger($id:String!,$passenger:PassengerInput!) {
        updatePassenger(id:$id,passenger:$passenger) {
          id
        }
      }`,
      variables: {
        id: passengerId,
        passenger: {
          updatedAt: new Date().toISOString(),
          alergias: newPassenger?.alergias,
          restriccionesAlimentarias: newPassenger?.restriccionesAlimentarias,
          condicionesMedicas: newPassenger?.condicionesMedicas
        }
      }
    });
  }

  updateServicesWithPaxAndMenu(params: any): Observable<any> {
    return this.queryGQL.mutateGraphQL<any>({
      mutation: `mutation updateServicesWithPaxAndMenu($params: FileInput!){
         updateServicesWithPaxAndMenu(params:$params){
          id,

        }
      }`,
      variables: { params }
    });
  }

  updateItinerary(id: any, itinerary: any): Observable<any> {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateItinerary($id: String!, $itinerary:inputItinerary_Dto!){
         updateItinerary(id:$id, itinerary:$itinerary){
          id
        }
      }`,
      variables: { id, itinerary }
    });
  }

  updateServiceItinerary(service: any): Observable<any> {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateServiceItinerary( $service:inputServices_Dto_extended!){
        updateServiceItinerary(service:$service){
          id
        }
      }`,
      variables: { service }
    });
  }

  updateHistorialService(
    service: any,
    user: any,
    change: any
  ): Observable<any> {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateHistorialService( $service:inputServices_Dto!, $user: String! ,$change: String!){
        updateHistorialService(service:$service, user:$user, change:$change)
      }`,
      variables: { service, user, change }
    });
  }

  getServicesByType(tipo: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getAllServicesByType($tipo: String!){
        getAllServicesByType(tipo:$tipo){
          id
          nombreServicio
          proveedor{
            id
            nombre
          }
        }
          }`,
      variables: { tipo }
    });
  }

  getProvidersByIds(ids: String[], projectionExpression?: string) {
    const fields = projectionExpression
      ? buildGraphQLFields(projectionExpression.split(',').map((f) => f.trim()))
      : 'id nombre';

    const query = `
     query getProvidersByIds($ids: [String!]!, $projectionExpression: String) {
    getProvidersByIds(ids: $ids, projectionExpression: $projectionExpression) {
        ${fields}
      }
    }
  `;

    return this.queryGQL.queryGraphQLSales<any>({
      query,
      variables: { ids, projectionExpression }
    });
  }

  getTicketsByIdService(idService: String, projectionExpression?: string) {
    const fields = projectionExpression
      ? buildGraphQLFields(projectionExpression.split(',').map((f) => f.trim()))
      : 'id idService';

    const query = `
     query getTicketsByIdServiceProjectExpression($idService: String!, $projectionExpression: String) {
    getTicketsByIdServiceProjectExpression(idService: $idService, projectionExpression: $projectionExpression) {
        ${fields}
      }
    }
  `;

    return this.queryGQL.queryGraphQLSales<any>({
      query,
      variables: { idService, projectionExpression }
    });
  }

  getTicketsByIdServNumOS(
    idService: String,
    numOS: number,
    projectionExpression?: string
  ) {
    const fields = projectionExpression
      ? buildGraphQLFields(projectionExpression.split(',').map((f) => f.trim()))
      : 'id ,idService ,numOS';

    const query = `
     query getTicketsByIdServNumOS($idService: String!,$numOS: Float!, $projectionExpression: String) {
    getTicketsByIdServNumOS(idService: $idService,numOS: $numOS, projectionExpression: $projectionExpression) {
        ${fields}
      }
    }
  `;

    return this.queryGQL.queryGraphQLSales<any>({
      query,
      variables: { idService, numOS, projectionExpression }
    });
  }

  getAllProvidersWithProjectionExpression(projectionExpression?: string) {
    const fields = projectionExpression
      ? buildGraphQLFields(projectionExpression.split(',').map((f) => f.trim()))
      : 'id nombre';

    const query = `
     query getAllProvidersWithProjectionExpression( $projectionExpression: String) {
    getAllProvidersWithProjectionExpression( projectionExpression: $projectionExpression) {
        ${fields}
      }
    }
  `;

    return this.queryGQL.queryGraphQLSales<any>({
      query,
      variables: { projectionExpression }
    });
  }

  /**
   * Proveedores por servicio (Sourcing).
   * Emite envelope { success, code, message, data }.
   * Si GraphQL trae errors[], lanza GetProvidersByServiceClientError.
   */
  getProvidersByService(
    nombreServicio: string,
    categoriaServicio: string = '',
    locacion: string = ''
  ): Observable<GetProvidersByServiceEnvelope> {
    return this.queryGQL
      .queryGraphQLSourcingEnvelope<{
        getProvidersByService: GetProvidersByServiceEnvelope | null;
      }>({
        query: `
      query GetProvidersByService(
        $nombreServicio: String!
        $categoriaServicio: String
        $locacion: String
      ) {
        getProvidersByService(
          nombreServicio: $nombreServicio
          categoriaServicio: $categoriaServicio
          locacion: $locacion
        ) {
          success
          code
          message
          data {
            tipoProveedor
            id
            nombre
            correoReserva
            servicioId
            tarifa {
              id
            }
          }
        }
      }`,
        variables: { nombreServicio, categoriaServicio, locacion }
      })
      .pipe(
        map((response) => {
          if (response.errors?.length) {
            throw parseProvidersByServiceGraphqlError(response.errors);
          }
          return normalizeProvidersByServiceEnvelope(
            response.data?.getProvidersByService
          );
        })
      );
  }

  getAllProviderByType(tipo: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getAllProviderByType($tipo: String!){
        getAllProviderByType(tipo:$tipo){
          nombre
          categoriaProveedor
        }
          }`,
      variables: { tipo }
    });
  }

  getProviderByName(name: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getProviderByName($name: String!){
        getProviderByName(name:$name){
          nombre
          id
        }
          }`,
      variables: { name }
    });
  }

  getProvider(id: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getProvider($id: String!){
        getProvider(id:$id){
          nombre

        }
          }`,
      variables: { id }
    });
  }

  getBiblia(key?: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getBiblia($key: String){
        getBiblia(key: $key){
        isThereMore,
        LastEvaluatedKey,
        lstBiblia{
          idItinerary
          estadoFile
          tipoSalida
          idActivity
          usuario
          obsActivity
          equipo
          fileNumberPadre
          dayName
          day
          dateBiblia
          diasItinerario
          dateFile
          dateRange
          agencia
          fileNumber
          nombreItinerario
          destino
          pickUp
          dropOff
          driver
          dateActualizacion
          usuarioOperador
          horaInicioOperacion
          horaProgramada

          lstPaX{
            Pax
            estado
            grupo
            acumulado
            passengerId
          }

          lstServicios{
            id,
            providerId,
            numOS,
            numReserva,
            fileName,
            fileNumber,
            tipoMoneda,
            totalCostoDolares,
            totalCostoSoles,
            nombreServicio,
            tipoServicio,
            tipoDeUnidad,
            varianteFrecuencia,
            horario,
            circuitoTren,
            tipoTarifaAlojamiento,
            categoriaServicio,
            observaciones,

            objProducto{
              id
              nombre
              destino
              locacion

            }



           incidencias{
             estado
             fechaCreated
             fechaSolved
             solutionTime
             tipoIncidencia
             reportedBy
             descIncidencia
             acciones
           }
          }
        }

        }
      }`,
      variables: { key }
    });
  }

  getBibliaByItineraryId(itineraryId: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getBibliaByItineraryId ($id:String!) {
        getBibliaByItineraryId (id:$id) {
          fileDisplayState
          idItinerary
          idActivity
          dateRange
          usuario
          dayName
          day
          lstPaX {
            flightIds
            Pax
            estado
            grupo
            grupoId
            acumulado
            paxMenu {
              menu {
                id
                nombreMenu
              }
              observaciones
            }
            type
            passengerId
          }
          dateBiblia
          diasItinerario
          dateFile
          agencia
          fileNumber
          nombreItinerario
          destino
          pickUp
          dropOff
          driver
          dateActualizacion
          usuarioOperador
          horaInicioOperacion
          horaProgramada
          equipo
          estadoFile
          tipoSalida
          vuelos {
            id
            itineraryId
            flightNumber
            flightCode
            flightDate
            arrivalTime
            departureTime
            airline
          }

          lstServicios {
            id
            numOS
            fileName
            fileNumber
            nombreServicio
            tipoServicio
            categoriaServicio
            observaciones
            tipoDeUnidad
            varianteFrecuencia
            horario
            circuitoTren
            tipoTarifaAlojamiento
              lstPaX {
                flightIds
                Pax
                estado
                grupo
                grupoId
                acumulado
                paxMenu {
                  menu {
                    id
                    nombreMenu
                  }
                  observaciones
                }
                type
                passengerId
              }
              incidencias {
                estado
                fechaCreated
                fechaSolved
                solutionTime
                tipoIncidencia
                reportedBy
                descIncidencia
                acciones
              }
              objProducto {
                id
                nombre
                destino
                locacion
              }

            objProvider {
              nombre
              transporteInfo {
                categoriaTransporte
                tipoUnidades
                servicioPrivado
              }
            }
          }
        }
      }`,
      variables: { id: itineraryId }
    });
  }

  getHistorialByIdActivity(idActivity: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getHistorialByIdActivity($idActivity: String!){
        getHistorialByIdActivity(idActivity: $idActivity){
          id,
          createdAt,
          idItinerary,
          idActivity,
          idServiceItinerary,
          user,
          change,
          user,
          service{
            id
            nombreServicio,
            tipoServicio,
            objProvider{
              nombre
            }
          }
        }
       }`,
      variables: { idActivity: idActivity }
    });
  }

  getAllPassengersByItineraryId({
    itineraryId,
    fields = {}
  }: {
    itineraryId: string;
    fields?: {
      id?: boolean;
      address?: boolean;
      age?: boolean;
      alergias?: boolean;
      city?: boolean;
      country?: boolean;
      dateOfBirth?: boolean;
      dateOfPass?: boolean;
      doe?: boolean;
      documentNumber?: boolean;
      documentType?: boolean;
      email?: boolean;
      firstName?: boolean;
      gender?: boolean;
      height?: boolean;
      idItinerary?: boolean;
      isTC?: boolean;
      lastName?: boolean;
      passportNumber?: boolean;
      phone?: boolean;
      residesInPeru?: boolean;
      restriccionesAlimentarias?: boolean;
      condicionesMedicas?: boolean;
      size?: boolean;
      status?: boolean;
      weight?: boolean;
    };
  }) {
    const selectedFields = Object.keys(fields)
      .filter((key) => fields[key as keyof typeof fields])
      .join(', ');
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getPassengersByItineraryId($itineraryId: String!) {
        getPassengersByItineraryId(idItinerary: $itineraryId) {
          ${selectedFields}
        }
       }`,
      variables: { idItinerary: itineraryId }
    });
  }

  getAllCountries() {
    return this.queryGQL.queryGraphQL<any>({
      query: `query {
        getAllCountries{
          id,
          codigo,
          Nombre_es,
          Nombre_eng,
        }
       }`
    });
  }

  getItineraryEquipos(itineraryId: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getItinerary($id: String!){
        getItinerary(id: $id){

            	id,
    			 equipos{
            id,
            nombreEquipo,
            marcaEquipo,
            modeloEquipo,
            tallaEquipo,
            valoracionEquipo,
            observacionEquipo,
            cantidad,
            costo,
            categoria
            estado,

          }
          estadoFile,
          dateRange,
          fileName,
          fileNumber,
          paxQuantity,
    			createdAt,
          updatedAt,
          itinerarios{
            services{
              id,
              contador,
              serviceId,
              providerId,

              productId,
              tipoServicio
            }
          }
         }
       }`,
      variables: { id: itineraryId }
    });
  }

  changeEstadoItinerarioByArg(id: any, estado: any, usuario: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation changeEstadoItinerarioByArg($id: String!, $estado: String!, $usuario: String!) {
        changeEstadoItinerarioByArg(id: $id, estado: $estado, usuario: $usuario)
      }`,
      variables: { id, estado, usuario }
    });
  }

  changeItinerarioComunidad(id: any, productId: any, comunidad: any) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation changeItinerarioComunidad($id: String!, $productId: String!, $comunidad: [String!]!) {
        changeItinerarioComunidad(id: $id, productId: $productId, comunidad: $comunidad)
      }`,
      variables: { id, productId, comunidad }
    });
  }

  getAllNotasCreditoProveedores() {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getAllNotasCreditoProveedores{
        getAllNotasCreditoProveedores{
        id
        codigo
        estado
        fileNumber
        nameProveedor
        reef
        partialPayment
        saf
        penalidad
        numberOS
        moneda
        idItinerary
        createdAt
        updatedAt
    }

}`,
      variables: {}
    });
  }

  // filesHijos{
  //   fileNumber
  //   nameClient
  //   nombreItinerario
  //   services {
  //     objServicio {
  //       tipoServicio
  //     }

  //     objProvider {
  //       nombre
  //     }
  //   }
  // }

  getProductsAventura({
    startDate,
    endDate,
    location,
    exclusiveStartKeyId = null
  }: {
    startDate: string | null;
    endDate: string | null;
    location: string;
    exclusiveStartKeyId: string | null;
  }) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getProductsAventura($startDate: String, $endDate: String, $location: String!, $exclusiveStartKeyId: String) {
        getProductsAventura(startDate: $startDate, endDate: $endDate, location: $location, exclusiveStartKeyId: $exclusiveStartKeyId) {
          productos {
            TC {
              id, firstName, lastName
            },
            pax {
              id, firstName, lastName
            },
            fileExtend,
            isSSFFPadre,
            filePadreId,
            fileNumber,
            fileDisplayState,
            nameClient,
            nombreItinerario,
            itineraryId,
            fechaInicio,
            fechaFin,
            fechaInicioProducto,
            fechaFinProducto,
            fechaLiberacion,
            comunidad
            dayInicio,
            dayFin,
            objProducto {
              nombre,
              categoriaProducto,
              id
              destino,
            }
            services {
              id,
              itineraryId,
              productId,
              serviceId,
              providerId,
              orderId,
              nombreItinerario,
              day,
              numOS,
              idContador,
              contador,
              comunidad
              fileNumber,
              dateRange,
              tipoServicio,
              cantPersonal,
              nombreServicio,
              mainGuide,
              ssffproduct
              categoriaServicio,
            }
            filesHijos {
              fileNumber
              nameClient
              nombreItinerario
              services {
                objServicio {
                  tipoServicio
                }
                objProvider {
                  nombre
                }
              }
            }
          },
          lastEvaluatedKeyId
        }
      }`,
      variables: { startDate, endDate, location, exclusiveStartKeyId }
    });
  }

  //Orden de Compra
  createOrdenCompra(model: any): Observable<any> {
    return this.queryGQL.mutateGraphQLFinancials<any>({
      mutation: `mutation createOrdenCompra($model: inputOrdenCompra!){
          createOrdenCompra(model: $model)
        }`,
      variables: { model }
    });
  }

  updateProviderOrdenCompra(model: any): Observable<any> {
    return this.queryGQL.mutateGraphQLFinancials<any>({
      mutation: `mutation updateProviderOrdenCompra($model: inputOrdenCompra!){
          updateProviderOrdenCompra(model: $model)
        }`,
      variables: { model }
    });
  }

  getAllOrdenCompra(): Observable<any> {
    return this.queryGQL.queryGraphQLFinancials<any>({
      query: `query{
          getAllOrdenCompra{
            id,
            codigoOC,
            fecha,
            nameProvider,
            codigoProvider,
            rucProvider,
            direccionProvider,
            area,
            cc,
            descripcionCC,
            moneda,
            tipoProvider,
            items{
              item,
              descripcion,
              cantidad,
              precioUnidad,
              inafecto,
              igv,
              monto
            },
            lstRegCompras{
              idRegistroCompra,
              monto,
              igv
            }
            subTotal,
            igv,
            total,
            saldoSubTotal,
            saldoIgv,
            saldoTotal,
            tipoPago,
            diasPago,
            fechaPago,
            observacion,
            usuario,
            aprobado,
            aprobadoBy
          }
        }`,
      variables: {}
    });
  }

  getAllProvidersSourcing(): Observable<any> {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query{
          getAllProvider{
            id,
            nombre,
            condicionesPagos{
              condicionPago,
              plazoDiasFit,
              plazoDiasGrupos,
              plazoDiasSeries
            },
            estadoProveedor,
            razonSocial,
            cuentaCorrienteSoles,
            cuentaCorrienteDolares,
            saldoSoles,
            saldoDolares,
            listSAF{
              id,
              codigo,
              fileNumber,
              os,
              monto,
              moneda,
              usuario,
              createdAt
            },
            numRUC,
            numDNI,
            tipoPersona,
            direccionLegal,
            pais,
            ubicacionOperativa,
            observaciones{
              tituloObservacion,
              textoObservacion
            },
            contactos{
              contactoNombre,
              contactoCargo,
              contactoCorreo,
              contactoCelular,
              contactoTelefono,
              contactoTelefonoAnexo
            },
            tipoProveedor
          }
        }`,
      variables: {}
    });
  }

  getAllWebSocketConnections() {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query{
          getAllWebSocketConnections{

            itineraryId,
            user,
            moduleName,
            connectionId

          }
        }`,
      variables: {}
    });
  }

  getActivityObservation(activityId: string, itineraryType: string) {
    return this.queryGQL.queryGraphQLSales<{
      getActivityObservation?: { observaciones?: string };
    }>({
      query: queryGetActivityObservation,
      variables: { activityId, itineraryType }
    });
  }

  updateObservacionesActivity(id: string, observaciones: string, type: string) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: mutationUpdateObservacionesActivity,
      variables: { id, observaciones, type }
    });
  }

  getCaratulaByItinerary(id: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query
        getCaratulaByItinerary($id:String!){
          getCaratulaByItinerary(id:$id){
              id
              idItinerary
              dayName
              dayNumber
              destino
              observaciones
              horaInicioOperacion
              horaProgramada
              isNew
            }
        }`,
      variables: { id }
    });
  }

  GetOrdenesServicioSiia(numberFile: String) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getNumberOSSiia($numberFile:String!){
          getNumberOSSiia(numberFile:$numberFile){
              id,
              numberFile,
              nameProveedor,
              nameServicio,
              numberOS,
              tipoMoneda,
              observacion,
              change,
          }
        }`,
      variables: { numberFile }
    });
  }

  getTarifa() {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query {
        getAllTarifa{
          id,
          monedaTarifa,
          tipoPax,
          servicio{
            id,
            nombreServicio,
            tipoServicio,
            categoriaServicio
            proveedorNombre
          }
          tarifaDia
          tarifaDiaSerie
          tarifaDiaSalidaFija
          tarifaDiaRack
          paxTarifa
          utilidad
          impuesto
          precioPasajero
          precioPasajeroRango{
            id
            value
          }

        }
      }`
    });
  }

  getServicesProduct(id: String) {
    return this.queryGQL.queryGraphQLProduct<any>({
      query: `
      query getServicesByProductId($id: String!){
        getServicesByProductId(id: $id){
          idServicio
          tarifa{
            id
          }
          nroPersonasPax{
            numPax
            id
          }
        }
      }
      `,
      variables: { id }
    });
  }

  queryServicesAndActivities({ itinearyIds }: { itinearyIds: String[] }) {
    return this.queryGQL.queryGraphQLSales<{ ServicesAndActivities: any }>({
      query: `
      query ServicesAndActivities($itinearyIds: [String!]!) {
        ServicesAndActivities(itinearyIds: $itinearyIds) {
          id,
          dayName,
          dayInProduct
          dayInItinerary,
          tipoSalida,
          dropOff,
          driver,
          usuarioOperador,
          horaProgramada,
          horaInicioOperacion,
          destino,
          dateActualizacion,
          idItinerary,
          isDeleted,
          observaciones,
          dayNumber,
          dayDestino,
          pickUp,
          pendingCsReviews,
          lstPaX {
            flightIds
            Pax
            estado
            grupo
            grupoId
            acumulado
            paxMenu {
              menu {
                id
                nombreMenu
              }
              observaciones
            }
            type
            passengerId
            pasajero {
              id,
              firstName,
              phone,
              lastName,
              alergias,
              restriccionesAlimentarias,
              condicionesMedicas,
              isTC,
              age
            }
          }
          services {
            id,
            providerId,
            numOS,
            idActivity,
            isDeleted,
            numReserva,
            fileName,
            fileNumber,
            tipoMoneda,
            totalCostoDolares,
            totalCostoSoles,
            nombreServicio,
            tipoServicio,
            circuitoTren,
            productId,
            serviceAdd,
            ssffproduct,
            tipoDeUnidad,
            varianteFrecuencia,
            horario,
            tipoTarifaAlojamiento,
            paxAlojamiento,
            categoriaServicio,
            observaciones,
            objProducto {
              id
              nombre
              destino
              locacion
            },
            incidencias {
              estado
              fechaCreated
              fechaSolved
              solutionTime
              tipoIncidencia
              reportedBy
              descIncidencia
              acciones
            }
          }
        }
      }`,
      variables: { itinearyIds }
    });
  }

  queryEquiposByitinearyIds({ itinearyIds }: { itinearyIds: string[] }) {
    return this.queryGQL.queryGraphQLSales<{
      EquiposByitinearyIds: any[];
    }>({
      query: `query EquiposByitinearyIds($itinearyIds: [String!]!) {
        EquiposByitinearyIds(itinearyIds: $itinearyIds) {
          id,
          agrupadoId,
          itineraryId
        }
      }`,
      variables: { itinearyIds }
    });
  }
  queryGetAllgrupadoEquipo() {
    return this.queryGQL.queryGraphQLSales<{
      getAllgrupadoEquipo: any[];
    }>({
      query: `query {
        getAllgrupadoEquipo {
          id,
          equipoId,
          nombreEquipo,
          nroPersonasPax
        }
      }`
    });
  }
  getProducts() {
    return this.queryGQL.queryGraphQLProduct<any>({
      query: `
      query {
          getAllProducts{
        id

      }
      }`
    });
  }

  getAllItinerariesSSFFPadre() {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query{
        getAllItinerariesSSFFPadre{
    			id,
          nombreItinerario,
          estadoFile,
          observaciones,
          dateRange,
          mainGuide{
            providerId,
            providerName
          }
          fileName,
          fileNumber,
          paxQuantity,
    			createdAt,
          updatedAt,
          lstPaX {
            flightIds
            Pax
            estado
            grupo
            grupoId
            acumulado
            paxMenu {
              menu {
                id
                nombreMenu
              }
              observaciones
            }
            type
            passengerId
          }
         incidencias{
              estado,
              fechaSolved,
              fechaCreated,
              solutionTime,
              tipoIncidencia,
              reportedBy,
              descIncidencia,
              acciones
            }

          comunidades{
            productId,
            comunidad
         }
        }
      }`,
      variables: {}
    });
  }

  getAllItineraries() {
    return this.queryGQL.queryGraphQLSales<{ getAllItineraries: File[] }>({
      query: `query{
        getAllItineraries{
    			id,
          isSSFFPadre,
          nombreItinerario,
          estadoFile,
          usuario,
          observaciones,
          dateRange,
          mainGuide{
            providerId,
            providerName
          }
          fileName,
          fileNumber,
          fileExtend,
          paxQuantity,
    			createdAt,
          updatedAt,
          lstPaX{
            Pax,
            estado,
            grupo,
            acumulado,
            passengerId
            flightIds
            paxMenu{
              observaciones,
              menu{
                id,
                nombreMenu
              }
            }
          },
         incidencias{
              estado,
              fechaSolved,
              fechaCreated,
              solutionTime,
              tipoIncidencia,
              reportedBy,
              descIncidencia,
              acciones
            }

          comunidades{
            productId,
            comunidad
         }
        }
      }`,
      variables: {}
    });
  }

  getChildFilesBySsffId({ ssffId }: { ssffId: string }) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query GetAllItinerariesSSFFHijoByPadreId ($filePadreId:String!) {
        getAllItinerariesSSFFHijoByPadreId (filePadreId:$filePadreId) {
          id,
          isSSFFPadre,
          nombreItinerario,
          pendingPreOpIncidents,
          lastMinute,
          estadoItinerario,
          estadoFile,
          observaciones,
          dateRange,
          mainGuide {
            providerId,
            providerName
          },
          fileName,
          fileNumber,
          paxQuantity,
    			createdAt,
          updatedAt,
          lstPaX {
            Pax,
            estado,
            grupo,
            acumulado,
            passengerId
            paxMenu{
              observaciones,
              menu{
                id,
                nombreMenu
              }
            }
          },
          comunidades {
            productId,
            comunidad
          }
        }
      }`,
      variables: { filePadreId: ssffId }
    });
  }

  getServiceFilesHijos(idItinerary: String) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query
    getServiceFilesHijos($idItinerary:String!){
      getServiceFilesHijos(idItinerary:$idItinerary){
            dayName
            nameProduct
            ssffproduct
            dayInProduct
            idContador
            typeServiceSSFF
            tipoTarifaAlojamiento
            tipoTarifaSelected
            editServiceOperation
            rangoTarifaTransporte{
              id
              numPax
            }

            nroUnidadesPaxTransporte{
              CUATROxCUATRO{
                numPax
                id
              }

              VAN{
                numPax
                id
              }


              H1{
                numPax
                id
              }


              SPRINTER_CORTA{
                numPax
                id
              }


              SPRINTER_LARGA{
                numPax
                id
              }

              BUS{
                numPax
                id
              }       MINI_BUS{
                numPax
                id
              }       AUTO_PRIVADO{
                numPax
                id
              }       CAMION_EQUIPOS{
                numPax
                id
              }
            }

            editTarifaSourcing
            objTarifa{
              id
              utilidad
              monedaTarifa
              comision
              precioPasajeroRango{
                id
                value
              }
              tipoPax
              tipoTarifa

              tarifaDia
              tarifaDiaSalidaFija
              tarifaDiaRack
              tarifasDiaSerie{
                clienteId
                tarifa
              }

            tarifasTipoUnidadesSerie{
              tarifaTipoUnidadesSerie{
                CUATROxCUATRO
                VAN
                SPRINTER_CORTA
                SPRINTER_LARGA
                BUS
                MINI_BUS
                AUTO_PRIVADO
                CAMION_EQUIPOS
                cliente
              }
            }

            tarifaTipoUnidades {
              CUATROxCUATRO
              VAN
              SPRINTER_CORTA
              SPRINTER_LARGA
              BUS
              MINI_BUS
              AUTO_PRIVADO
              CAMION_EQUIPOS
            },


            tarifaTipoUnidadesSalidaFija {
              CUATROxCUATRO
              VAN
              SPRINTER_CORTA
              SPRINTER_LARGA
              BUS
              MINI_BUS
              AUTO_PRIVADO
              CAMION_EQUIPOS
            },



            tarifaTipoUnidadesRack {
              CUATROxCUATRO
              VAN
              SPRINTER_CORTA
              SPRINTER_LARGA
              BUS
              MINI_BUS
              AUTO_PRIVADO
              CAMION_EQUIPOS
            },

            tarifasTipoHabitacionSerie{
                          SWB
                          DWB
                          TRPL
                          clienteId
                }
              tarifaTipoHabitacion{
              SWB,
              DWB,
              TRPL
              }

            tarifaTipoHabitacionRack{
              SWB,
              DWB,
              TRPL
              }



            tarifaTipoHabitacionSalidaFija{
              SWB,
              DWB,
              TRPL
              }



            }

            id
            idActivity
            tipoDeTren
            tipoTarifaSelected
            tipoDeUnidad
            idItinerary
            idInvoice
            isAccounted
            mainGuide
            price
            costo
            tipoMoneda
            margen
            editTarifa,
            editOperation,
            cantPersonal
            objProducto{
              inicioActividad,
            }
            lstPaX{
              Pax
              estado
              grupo
              grupoId
              acumulado
              paxMenu{
                menu{
                  id
                  nombreMenu
                }
                observaciones
              }
             passengerId


              }
              id

            nombreItinerario
            fileName
            fileNumber
            serviceId
            productId
            providerId
            tarifaId
            day
            price
            costo
            utilidad


            margen
            cantPersonal
            totalPriceSoles
            totalCostoDolares
            totalCostoSoles
            totalPriceDolares
            tipoServicio
            tipoMoneda
            nombreServicio
            observaciones
            categoriaServicio
            createdAt
            updatedAt

            isDeleted
            numReserva
            estadoReserva
            estadoOS
            pagoTesoreria
            numOS
            contador
            idContador

            historial
            incidencias{
              tipoIncidencia
              reportedBy
              descIncidencia
            }



            objProvider{
              nombre
            }

            objTarifa{
              id,
              tarifaDia,

               comision
               tipoPax,
               tipoTarifa
               monedaTarifa,
               utilidad,



               precioPasajeroRango{
                id
                value
              },

              tarifasDiaSerie{
              clienteId
              tarifa
              }


               tarifaTipoUnidades{
                CUATROxCUATRO
                VAN
                SPRINTER_CORTA
                SPRINTER_LARGA

                }
                tarifaTipoHabitacion{
                SWB
                DWB
                TRPL

                  }
            }

          }
        }
      `,
      variables: { idItinerary }
    });
  }

  addPersonaExtra(id: String, horaProgramada: String) {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `
          mutation updateHoraProgramada($id:String!, $horaProgramada:String!){
            updateHoraProgramada(id:$id, horaProgramada:$horaProgramada){
              horaProgramada
            }
          }
      `,
      variables: { id, horaProgramada }
    });
  }

  getPassengersByIds({
    passengerIds = [],
    passengerFields = {}
  }: {
    passengerIds: string[];
    passengerFields?: PassengerFields;
  }) {
    if (passengerIds.length === 0) {
      throw new Error('passengerIds array cannot be empty');
    }
    const fieldsString = Object.keys(passengerFields || {})
      .filter((key) => passengerFields[key as keyof typeof passengerFields]) // Only include fields that are true
      .join(', ');

    // Fallback if no fields are specified, though your requirements imply usage of 'fields'
    const finalFields = fieldsString || 'id, firstName, lastName';

    return this.queryGQL.queryGraphQLSales<any>({
      query: `query GetPassengersByIds (
        $passengerIds: [String!]!,
        $passengerFields: String
      ) {
        getPassengers(passengerIds: $passengerIds, passengerFields: $passengerFields) {
          ${finalFields}
        }
      }`,
      variables: { passengerIds, passengerFields: finalFields }
    });
  }

  getAssignedPassengers({
    itineraryId,
    passengerFields = {}
  }: {
    itineraryId: string;
    passengerFields?: PassengerFields;
  }) {
    const fieldsString = Object.keys(passengerFields || {})
      .filter((key) => passengerFields[key as keyof typeof passengerFields]) // Only include fields that are true
      .join(', ');

    // Fallback if no fields are specified, though your requirements imply usage of 'fields'
    const finalFields = fieldsString || 'id, firstName, lastName';

    return this.queryGQL.queryGraphQLSales<any>({
      query: `query GetAssignedPassengers (
        $itineraryId: String!,
        $passengerFields: String
      ) {
        getAssignedPassengers(itineraryId: $itineraryId, passengerFields: $passengerFields) {
          ${finalFields}
        }
      }`,
      variables: { itineraryId, passengerFields: finalFields }
    });
  }
}
